module.exports = __webpack_public_path__ + "static/image-samples-complete-604344d7c97be784ab0da982b850718b.png";